/** @jsx jsx */
import { GatsbyImage } from 'gatsby-plugin-image'
import { Box, Container, Grid, Heading, jsx } from 'theme-ui'

const LogoPool = ({
  condensed = false,
  description,
  images,
  subtitle,
  title,
}) => {
  return (
    <Box
      bg="white"
      pt={!condensed ? [7, null, 9, 13] : [4, null, 5, 6]}
      pb={!condensed ? [6, null, 8, 12] : [2, null, 3, 4]}
    >
      <Container>
        <Grid columns={[1, 12]}>
          <Box
            mb={!condensed ? [1, 2, null, 4] : [1, 2]}
            sx={{
              gridColumn: [null, '3 / 11', null, '4 / 10'],
              textAlign: 'center',
            }}
          >
            {title && (
              <Heading as="h2" variant={'title2'}>
                {title}
              </Heading>
            )}
            {subtitle && (
              <Heading as="p" variant={'subtitle2'}>
                {subtitle}
              </Heading>
            )}
            {description && (
              <Box
                sx={{
                  variant: 'text.body1',
                  a: {
                    variant: 'text.link',
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: description.childMarkdownRemark.html,
                }}
              />
            )}
          </Box>
        </Grid>
        <Grid
          columns={!condensed ? [2, 3, 4, 5] : [2, 3, null, 6]}
          gap={!condensed ? 0 : [0, 2, 3]}
        >
          {images.map((image, index) => (
            <GatsbyImage
              image={image.gatsbyImageData}
              key={`logo-${index}`}
              alt={image.description}
            />
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default LogoPool
